import Dashboard from "views/Dashboard.js";
import UserList from "views/UserList.js";
import DBSegment from "views/DBSegment.js";
import Rewards from "views/Rewards.js";
import RokuConfig from "views/RokuConfig.js";
import Analytics from "views/Analytics.js";
import IPConfig from "views/IPConfig.js";
import MultiDevicesAnalytics from "views/MultiDevicesAnalytics.js";
import RokuRemoteApp from "views/RokuRemoteApp.js";
import Notification from "views/Notification.js";
// import TargetedAds from "views/TargetedAds.js";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "tim-icons icon-chart-pie-36",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/user",
    name: "User List",
    icon: "tim-icons icon-paper",
    component: UserList,
    layout: "/admin",
  },
  {
    path: "/db-segment",
    name: "DB Segment",
    icon: "tim-icons icon-credit-card",
    component: DBSegment,
    layout: "/admin",
  },
  {
    path: "/rewards",
    name: "Rewards",
    icon: "tim-icons icon-gift-2",
    component: Rewards,
    layout: "/admin",
  },
  {
    path: "/notification",
    name: "Notification",
    icon: "tim-icons icon-bell-55",
    component: Notification,
    layout: "/admin",
  },
  {
    path: "/roku-config",
    name: "Roku Config",
    icon: "tim-icons icon-notes",
    component: RokuConfig,
    layout: "/admin",
  },
  // {
  //   path: "/targeted ad",
  //   name: "Targeted ads",
  //   icon: "tim-icons icon-bulb-63",
  //   component: TargetedAds,
  //   layout: "/admin",
  // },
  {
    path: "/ip-config",
    name: "IP Config",
    icon: "tim-icons icon-molecule-40",
    component: IPConfig,
    layout: "/admin",
  },
  {
    path: "/roku-remote-app",
    name: "Roku Remote",
    icon: "tim-icons icon-mobile",
    component: RokuRemoteApp,
    layout: "/admin",
  },
  {
    path: "/analytics",
    name: "Analytics",
    icon: "tim-icons icon-components",
    component: Analytics,
    layout: "/admin",
  },
  {
    path: "/multi-devices-analytics",
    name: "Multi Devices",
    icon: "tim-icons icon-app",
    component: MultiDevicesAnalytics,
    layout: "/admin",
  },
];

export default routes;
